const isAuthenticated = state => state.userLogged;
const getMonths = state => state.months;

export { isAuthenticated, getMonths };
